import * as React from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import qs from 'qs';
import { useRequest } from '../../hooks/requestHook';
import { useProducerColumns } from '../../hooks/useColumns';
import useFetch from '../../hooks/useFetch';
import { producer as api } from '../../api';
import PageLayout from '../atoms/PageLayout';
import MaterialTable from '../MaterialTable';
import { decamelize } from '../../utils/camelize';
var AdminProducersPage = function () {
    var location = useLocation();
    var t = useTranslation().t;
    var getAll = useRequest(api.getAll);
    var query = qs.parse(location.search.slice(1));
    var initialPage = parseInt((query.page || '')) || 0;
    var pageSize = parseInt((query.pageSize || '')) || 25;
    var producerColumns = useProducerColumns({
        filters: query.filters,
        orderBy: query.orderBy,
        orderDirection: query.orderDirection,
    });
    var columns = [
        producerColumns.id,
        producerColumns.company,
        producerColumns.email,
        producerColumns.lastname,
        producerColumns.firstname,
        producerColumns.country,
        producerColumns.farmersCount,
        producerColumns.createdAt,
    ];
    var buildFilterParams = React.useCallback(function (query) {
        var q = {};
        query.filters.forEach(function (filter) {
            switch (filter.column.field) {
                case 'email':
                    q.maintainer_email_cont = filter.value;
                    break;
                case 'country':
                    q.with_country = filter.value;
                    break;
                default:
                    if (filter.column.field) {
                        q["".concat(decamelize(filter.column.field), "_cont")] =
                            filter.value;
                    }
                    break;
            }
        });
        return q;
    }, []);
    var fetchProducers = useFetch({
        buildFilterParams: buildFilterParams,
        api: getAll,
    });
    return (React.createElement(PageLayout, { title: t('pages.adminProducers.title') },
        React.createElement(MaterialTable, { model: "producer", columns: columns, data: fetchProducers, detailPath: function (_a) {
                var id = _a.id;
                return "/admin/producers/".concat(id);
            }, options: {
                initialPage: initialPage,
                pageSize: pageSize,
                paging: true,
                filtering: true,
                filterCellStyle: {
                    minWidth: 100,
                },
            } })));
};
export default AdminProducersPage;
